'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helper = require('./helper');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PdfDocumentViewer = function (_React$Component) {
    _inherits(PdfDocumentViewer, _React$Component);

    function PdfDocumentViewer(props) {
        _classCallCheck(this, PdfDocumentViewer);

        var _this = _possibleConstructorReturn(this, (PdfDocumentViewer.__proto__ || Object.getPrototypeOf(PdfDocumentViewer)).call(this, props));

        var blob = (0, _helper.getBlob)(_this.props.bytes);
        _this.state = {
            blobUrl: window.URL.createObjectURL(blob)
        };
        return _this;
    }

    _createClass(PdfDocumentViewer, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.URL.revokeObjectURL(this.state.blobUrl);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'pdf-document-viewer-comp' },
                _react2.default.createElement(
                    'object',
                    { data: this.state.blobUrl,
                        title: this.props.pdfTitle,
                        type: 'application/pdf',
                        width: '100%',
                        height: '100%' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'This browser does not support inline PDFs. Please download the PDF to view it: ',
                        _react2.default.createElement(
                            'a',
                            { href: this.state.blobUrl },
                            'Download PDF'
                        )
                    )
                )
            );
        }
    }]);

    return PdfDocumentViewer;
}(_react2.default.Component);

PdfDocumentViewer.propTypes = {
    bytes: _propTypes2.default.object,
    pdfTitle: _propTypes2.default.string
};

PdfDocumentViewer.defaultProps = {
    pdfTitle: 'PDF'
};

exports.default = PdfDocumentViewer;
//# sourceMappingURL=index.js.map